export function convertStringToJSON(str: string): any {
    let json = {};
    try {
        json = JSON.parse(str);
    } catch (e) {
        console.error('Error parsing JSON string', e);
    }
    return json;
}